<template>
    <div>
        <index v-if="activePage === 'tasks.index'" />
        <create v-if="activePage === 'tasks.create'" />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import Index from '../components/tasks/ClientTaskIndex'
import Create from '../components/tasks/Create'

export default {
    name: 'TasksContainer',

    components: {
        Index,
        Create,
    },

    props: {
        client: 0,
    },

    created() {
        this.$store.commit('browsing/SET_PAGE_NAME', 'tasks.index')
        this.$store.commit('browsing/SET_CLIENT_ID', this.client)
    },

    computed: {
        ...mapState({
            activePage: (state) => state.browsing.pageName,
        }),
    },
}
</script>

<style scoped></style>
